import { getCommonWidget } from '../../dashWidgetHelper'
import { getHaBarDetailedByMonthAndGeo, getHaLineDetailedByMonthAndGeo } from '../widgetsFunctionsHa'
import { commonWidgets, haTrendDataMapper, haWordCountWithLinksMapper } from './../commonWidgetsHa'


const getHospitalesServiciosExternosWidgets = () => [
    {
        title: 'Hospitales',
        type: 'label',
        size: [4, 1]
    },
    /**
     * NPS
     */
    getHaLineDetailedByMonthAndGeo({
        key: `nps-root-line`,
        indicator: 'NPS_GENERAL',
        title: 'NPS General por región',
        size: [4, 4],
        formula: 'nps-10',
        extraConfigs: {
            backgroundColor: '#3a1b52',
            theme: 'dark',
        },
        criticals: [
            { key: 'servExt', criticalMoments: [12051], label: 'Servicios externos' }
        ]
    }),
    getHaBarDetailedByMonthAndGeo({
        key: `nps-root-bar`,
        indicator: 'NPS_GENERAL',
        title: 'NPS General por región',
        size: [4, 4],
        formula: 'nps-10',
        extraConfigs: {
            backgroundColor: '#3a1b52',
            theme: 'dark',
        },
        criticals: [
            { key: 'servExt', criticalMoments: [12051], label: 'Servicios externos' }
        ]
    }),
    /**
     * Satisfacción
     */
    getHaLineDetailedByMonthAndGeo({
        key: `csat-root-line`,
        indicator: 'CSAT_GENERAL',
        title: 'Satisfacción General por mes',
        size: [4, 4],
        formula: 'nps-5',
        extraConfigs: {
            backgroundColor: '#3a1b52',
            theme: 'dark',
        },
        criticals: [
            { key: 'servExt', criticalMoments: [12051], label: 'Servicios externos' }
        ]
    }),
    getHaBarDetailedByMonthAndGeo({
        key: `csat-root-bar`,
        indicator: 'CSAT_GENERAL',
        title: 'Satisfacción General por región',
        size: [4, 4],
        formula: 'nps-5',
        extraConfigs: {
            backgroundColor: '#3a1b52',
            theme: 'dark',
        },
        criticals: [
            { key: 'servExt', criticalMoments: [12051], label: 'Servicios externos' }
        ]
    })
]

export default {
    title: 'Hospital Angeles Servicios Externos de Diagnóstico',
    description: 'Hospital Angeles Servicios Externos de Diagnóstico',
    widgets: (filters: FiltersUI) => {
        return [
            {
                title: 'NPS',
                type: 'label',
                //position: [0, 0],
                size: [1, 1],
                config: { color: '#B7AADC' },
            },
            {
                title: 'Satisfacion',
                type: 'label',
                //position: [1, 0],
                size: [1, 1],
                config: { color: '#B7AADC' },
            },
            {
                title: 'Servicio',
                type: 'label',
                //position: [1, 0],
                size: [2, 1],
                config: { color: '#B7AADC' },
            },
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'haTrendByGeo',
                title: 'NPS',
                //position: [2, 4],
                size: [1, 2],
                mapper: haTrendDataMapper,
                indicator: 'servicios_externos_diagnostico_pregunta_14',
                criticalMomentInclude: [12051],
                extraConfigs: {
                    valueSymbol: '',
                    showTrend: true

                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'haTrendByGeo',
                title: 'Satisfacción General con el servicio',
                //position: [2, 2],
                size: [1, 2],
                mapper: haTrendDataMapper,
                indicator: 'servicios_externos_diagnostico_pregunta_6',
                criticalMomentInclude: [12051],
                extraConfigs: {
                    valueSymbol: '',
                    showTrend: true
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: 'Indique por favor el servicio en que recibió atención',
                //position: [0, 3],
                size: [2, 2],
                extraConfigs: {
                    showSample: true,
                    itemGap: 10,
                    marginLeft: 200,
                },
                indicator: 'servicios_externos_diagnostico_pregunta_3',
                criticalMomentInclude: [12051]
            }),


            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: '¿Qué lo motivó a elegirnos para su atención?',
                //position: [1, 1],
                size: [4, 2],
                extraConfigs: {
                    showSample: true
                },
                indicator: 'servicios_externos_diagnostico_pregunta_1',
                criticalMomentInclude: [12051]
            }),


            {
                title: 'Evaluación General',
                type: 'label',
                //position: [0, 5],
                size: [4, 1],
                // config: { color: '#B7AADC' },
            },
            /* getCommonWidget({
               commonWidgets: commonWidgets,
               name: 'haTrendByGeo',
               title: 'Satisfacción General con el servicio',
               //position: [0, 6],
               size: [1, 2],
               mapper: haTrendDataMapper,
               indicator: 'servicios_externos_diagnostico_pregunta_6',
               criticalMomentInclude: [12051],
               extraConfigs:{
                   valueSymbol:''
               }
             }),
             */
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'haTrendByGeo',
                title: 'Atención del personal que lo recibió en el servicio',
                //position: [1, 6],
                size: [1, 2],
                mapper: haTrendDataMapper,
                indicator: 'servicios_externos_diagnostico_pregunta_7',
                criticalMomentInclude: [12051],
                extraConfigs: {
                    valueSymbol: ''
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'haTrendByGeo',
                title: 'Claridad de las indicaciones para presentarse al estudio (aseo, ayuno, etc.)',
                //position: [2, 6],
                size: [1, 2],
                mapper: haTrendDataMapper,
                indicator: 'servicios_externos_diagnostico_pregunta_8',
                criticalMomentInclude: [12051],
                extraConfigs: {
                    valueSymbol: ''
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'haTrendByGeo',
                title: 'Tiempo de espera para realizarse el estudio',
                //position: [3, 6],
                size: [1, 2],
                mapper: haTrendDataMapper,
                indicator: 'servicios_externos_diagnostico_pregunta_9',
                criticalMomentInclude: [12051],
                extraConfigs: {
                    valueSymbol: ''
                }
            }),
            /*{
               title: 'Evaluación General',
               type: 'label',
              // position: [0, 8],
               size: [4, 1],
              },
              */
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'haTrendByGeo',
                title: 'Servicio y habilidades del personal técnico, de enfermería o médico durante el procedimiento',
                //position: [0, 9],
                size: [1, 2],
                mapper: haTrendDataMapper,
                indicator: 'servicios_externos_diagnostico_pregunta_10',
                criticalMomentInclude: [12051],
                extraConfigs: {
                    valueSymbol: ''
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'haTrendByGeo',
                title: 'Condiciones físicas y limpieza de las instalaciones',
                //position: [1, 9],
                size: [1, 2],
                mapper: haTrendDataMapper,
                indicator: 'servicios_externos_diagnostico_pregunta_11',
                criticalMomentInclude: [12051],
                extraConfigs: {
                    valueSymbol: ''
                }
            }),
            /*{
                      size: [3, 2],
                      type: 'empty-space',
                  },
           */
            /*getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'wordCountWithLinks',
                title: 'Nube de Palabras / Frecuencia en comentarios',
                //position: [2, 11],
                size: [3, 2],
                mapper: haWordCountWithLinksMapper,
                criticalMomentInclude: [12051]
            }),*/
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'wordCount',
                title: 'Nube de Palabras / Frecuencia en comentarios',
                size: [3, 2],
                helpText: 'Nube de Palabras / Frecuencia en comentarios',
                criticalMomentInclude: [12051]
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'textAnalysis',
                //position:[0,11], 
                size: [4, 3],
                indicator: 'SENTIMENT',
                criticalMomentInclude: [12051],
                extraConfigs: {
                    hideBars: false
                }
            }),
            ...getHospitalesServiciosExternosWidgets()
        ]
    },
} as DasboardConfig
